class Payment {
	id = 0;
	date = null;
	payment_category_id = null;
	member_id = null;
	amount = null;
	invoice_text = null;
	excerpt_number = null;
	category_display = null;
	member_display = null;
	payment_form_id = null;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Payment;
